import type { StateCreator } from 'zustand'

interface State {
  chatMarginTop: number
  chatMarginBottom: number
}

interface Actions {
  setChatMarginTop: (marginTop: number) => void
  setChatMarginBottom: (marginBottom: number) => void
}

export type LiveLayoutsSlice = State & Actions

export const liveLayoutsStore: StateCreator<
  LiveLayoutsSlice,
  [],
  [],
  LiveLayoutsSlice
> = (set) => ({
  chatMarginTop: 0,
  chatMarginBottom: 0,
  setChatMarginTop: (marginTop) => {
    set({ chatMarginTop: marginTop })
  },
  setChatMarginBottom: (marginBottom) => {
    set({ chatMarginBottom: marginBottom })
  },
})
